import { z } from 'zod'
import { defineAction } from '~/prix'
import { spaceForPoint } from '~/prix/types/presets/space'
import geoListAction from './geoList.action.json' with { type: 'json' }

const geoListDefinition = defineAction({
  ...geoListAction,

  input: z.object({
    spaces: z
      .array(
        spaceForPoint().extend({
          delimitationKey: z.string().nullish(),
        }),
      )
      .optional(),
    highResolution: z.boolean().optional(),
    query: z.string().optional(),
    limit: z.number().min(1).optional(),
    include: z.array(z.string()).optional(),
    isSearch: z.boolean().optional(),
  }),
  output: z.object({
    items: z.array(
      z.object({
        id: z.union([z.number(), z.string()]),
        key: z.string().nullish(),
        name: z.string().nullish(),
        subtitle: z.string().nullish(),
        shape: z.any().nullish(),
        point: z.any().nullish(),
        path: z.any().nullish(),
        type: z.string().nullish(),
        municipalityId: z.union([z.number(), z.string()]).nullish(),
        searchRanking: z.number().nullish(),
        source: z.string().nullish(),
      }),
    ),
  }),
  cache: input => {
    if (
      input.highResolution ||
      input.spaces?.some(
        space => space?.delimitationType === 'custom' || space?.childrenType === 'custom',
      )
    ) {
      return {}
    }
    return {
      back: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 7, // 7 days
        expirationMsForUpdate: 1000 * 60 * 60 * 24 * 1, // 1 day
      },
      front: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 7, // 7 days
        expirationMsForUpdate: 1000 * 60 * 60 * 24 * 1, // 1 day
      },
    }
  },
})

export default geoListDefinition
